import { Alert } from "@mui/material";

import { ContextoRetencao, estaParado, textosDoModal } from "./retencao-vocabulario";

/**
 * A pergunta de confirmação do modal de retenção (tirar retenção, marcar como
 * corrigido), igual nas quatro telas.
 *
 * Existe como componente porque a condição inline `A || B && (<Alert/>)`, por
 * precedência, só mostrava o aviso para Retido e nunca para RETAINED, nas três
 * telas de aprovação (corrigido na PR #632).
 */
export function RetencaoAviso({
  status,
  contexto,
}: {
  status: string | undefined;
  contexto: ContextoRetencao;
}) {
  const { aviso } = textosDoModal(status, contexto);
  if (!estaParado(status) || !aviso) return null;
  return (
    <Alert severity="info" variant="standard" style={{ marginBottom: "20px" }}>
      {aviso}
    </Alert>
  );
}
